<template>
    <td-dialog
        :title="$t('tokenInfo.GEN_TOKEN')"
        :before-close="tokenDialogClose"
        :visible.sync="dialogTokenVisible"
        width="800px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="10vh"
    >
        <el-form :model="formToken" ref="formTokenInfo" :rules="rules">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="TAG" label-width="60px" prop="tag">
                        <td-input placeholder="common.PLEASE_INPUT" v-model="formToken.tag" :readonly="formDisabled"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.VALIDITY_TO')" label-width="80px" prop="validTime">
                        <td-date-time
                            :editable="false"
                            v-model="formToken.validTime"
                            type="date"
                            :pickerOptions="pickerOptions0"
                            :readonly="formDisabled"
                            :placeholder="$t('tokenInfo.VALID_TIME')"
                        ></td-date-time>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="padding-top:20px">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>{{ $t('common.ROLE_INFO') }}</span>
                    </div>
                    <el-collapse accordion>
                        <el-collapse-item :title="$t('role.COMMON_ROLE')" :name="item">
                            <el-row>
                                <el-col :span="11">
                                    <el-form-item :label="$t('role.ORG_ROLE')">
                                        <td-button class="treeStyle" :disabled="formDisabled" @click="showTree()">{{ $t('common.CHOOSE') }}</td-button>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10" style="padding-left:30px">
                                    <el-form-item :label="$t('userInfo.ORG_GROUP')">
                                        <td-button class="treeStyle" :disabled="formDisabled" @click="showOrgGroupTree()">{{ $t('common.CHOOSE') }}</td-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item :label="$t('userInfo.HAS_SELECTED_ORG') + this.orgNameList" style="font-size:10px" />
                        </el-collapse-item>
                        <el-collapse-item :title="$t('role.DOOR_ROLE')" :name="item">
                            <td-checkbox-group
                                :allList="doorRoleList"
                                v-model="formToken.doorRole"
                                ref="doorRoleCheckGroup"
                                keys="sId"
                                text="sName"
                                :labelWidth="85"
                                :overLenghOmission="true"
                                checkBoxClass="checkboxstyle"
                                :disabled="formDisabled"
                            ></td-checkbox-group>
                        </el-collapse-item>
                        <el-collapse-item v-for="(item, index) in roleInfoList" :title="item.sRoleTypeName" :key="index">
                            <td-checkbox-group
                                :allList="item.listRoleVo"
                                v-model="item.checkRoleIdList"
                                ref="roleCheckGroup"
                                keys="id"
                                text="roleName"
                                :labelWidth="85"
                                :overLenghOmission="true"
                                checkBoxClass="checkboxstyle"
                                :disabled="formDisabled"
                            ></td-checkbox-group>
                        </el-collapse-item>
                    </el-collapse>
                </el-card>
            </el-row>
        </el-form>
        <div class="genStyle">
            <td-button type="primary" @click="generateToken('formTokenInfo')" :disabled="generateDisabled" :loading="genLoading">{{ $t('tokenInfo.GENERATE') }}</td-button>
        </div>
        <el-row style="margin-top:-10px">
            <span class="resultStyle">{{ $t('tokenInfo.TOKEN_RESULT') }}</span>
        </el-row>
        <el-row style="margin-bottom:10px">
            <td-input type="textarea" v-model="tokenValue" width="600" placeholder="" readonly></td-input>
        </el-row>
        <el-row v-if="nodeShow" style="margin-top:-5px">
            <span style="color:red;">{{ $t('tokenInfo.TOKEN_NOTE') }}</span>
        </el-row>
        <dialogOrgTree
            v-if="dialogOrgTreeVisible"
            :title="titleOrg"
            :dialogOrgTreeVisible="dialogOrgTreeVisible"
            :orgTreeUrl="orgTreeUrl"
            :checkedOrgIdList="this.checkedOrgIdList"
            ref="addOrModifyInfo"
            @orgTreeDialogClose="orgTreeDialogClose"
            @getCheckedOrgList="getCheckedOrgList"
        ></dialogOrgTree>
        <dialogOrgGroupTree
            v-if="dialogOrgGroupTreeVisible"
            :title="titleOrgGroup"
            :dialogOrgGroupTreeVisible="dialogOrgGroupTreeVisible"
            :orgTreeUrl="orgGroupTreeUrl"
            :checkedOrgIdList="checkedOrgIdList"
            ref="addOrModifyOrgGroupInfo"
            @orgTreeDialogClose="orgTreeDialogClose"
            @getCheckedOrgList="getCheckedOrgList"
        ></dialogOrgGroupTree>
        <span slot="footer">
            <td-button type="button" @click.native="tokenDialogClose">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import resourceApi from './../../user/assets/api.js';
import dialogOrgTree from './../../user/components/dialogOrgTree.vue';
import dialogOrgGroupTree from './../../user/components/dialogOrgGroupTree.vue';
export default {
    // 初始化渲染
    components: {
        dialogOrgTree,
        dialogOrgGroupTree
    },
    props: ['dialogTokenVisible', 'sysList', 'sysFlg', 'editItem', 'isDetail'],
    created() {
        //查询角色信息按角色类型分组
        this.getAllRoleByType();
        //初始化门禁、人事角色
        this.initDoorRole();
        //获取树形查询的url
        this.getTreeUrl();
        //初始化角色
        if (this.isDetail) {
            this.nodeShow = true;
            this.formDisabled = true;
            this.formToken.tag = this.editItem.tag;
            this.formToken.validTime = this.editItem.dateTo;
            this.generateDisabled = true;
        }
    },
    mounted() {},
    data() {
        return {
            formToken: {
                tag: '',
                validTime: '',
                doorRole: ''
            },
            tokenValue: '', //生成的token
            genLoading: false,
            nodeShow: false,
            formDisabled: false,
            generateDisabled: false,
            orgNameList: [],
            orgIdList: [],
            doorRoleList: [],
            roleInfoList: [],
            dialogOrgTreeVisible: false,
            dialogOrgGroupTreeVisible: false,
            orgTreeUrl: { query: '', search: '' },
            orgGroupTreeUrl: { query: '', search: '' },
            checkedOrgIdList: [],
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                }
            },
            // 对表单进行数据验证
            rules: {
                tag: [
                    { required: true, message: this.$t('tokenInfo.INPUT_TOKEN'), trigger: 'change' },
                    {
                        pattern: this.$regex.USERCAPTION_RULE,
                        message: this.$t('error.ERROR_USER_CAPTION_ILLEGAL')
                    }
                ],
                validTime: [{ required: true, message: this.$t('tokenInfo.INPUT_VALID'), trigger: 'change' }]
            }
        };
    },
    methods: {
        //初始化编辑数据
        initEditData() {
            let param = {
                sId: this.editItem.userId,
                sysID: this.sysFlg,
                orgFlg: 1
            };
            resourceApi.getUserRoleInfo(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserRoleInfo', response.data.statusMessage);
                    return;
                }
                let array = response.data.content;
                let orgIds = [];
                let orgNames = [];
                let result = [];
                for (let index = 0; index < array.length; index++) {
                    orgIds.push(array[index].sId);
                    orgNames.push(array[index].sName);
                    result.push({ id: array[index].sId, caption: array[index].sName });
                }
                this.checkedOrgIdList = result;
                this.orgNameList = orgNames.join(',');
            });
            let doorRoleQueryParam = {
                sId: this.editItem.userId,
                sysFlg: this.sysFlg,
                orgFlg: 2
            };
            resourceApi.getUserRole(JSON.stringify(doorRoleQueryParam), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserRole', response.data.statusMessage);
                    return;
                }
                let array = response.data.content;
                let tempArray = [];
                if (array.length > 0) {
                    array.forEach(role => {
                        tempArray.push(role.sId);
                    });
                    this.formToken.doorRole = tempArray;
                }
            });
            this.roleInfoList.forEach(element => {
                let param = {
                    sId: this.editItem.userId,
                    sysFlg: this.sysFlg,
                    orgFlg: element.orgFlg
                };
                resourceApi.getUserRole(JSON.stringify(param), response => {
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('user/getUserRole', response.data.statusMessage);
                        return;
                    }
                    let array = response.data.content;
                    let tempArray = [];
                    if (array.length > 0) {
                        array.forEach(role => {
                            tempArray.push(role.sId);
                        });
                        element.checkRoleIdList = tempArray;
                    }
                });
            });
        },
        //获取树形查询的url
        getTreeUrl() {
            let arr = this.sysList;
            for (let index in arr) {
                if (arr[index].sSysFlg === this.sysFlg) {
                    let hostUrl = arr[index].sUrl;
                    let deptUrl = arr[index].sDeptUrl;
                    this.orgTreeUrl.query = hostUrl + deptUrl;
                    this.orgTreeUrl.search = hostUrl + '/OrgManagerController/find';
                    this.orgGroupTreeUrl.query = hostUrl + '/OrgStructureController/findOrgStructureTree';
                    this.orgGroupTreeUrl.search = hostUrl + '/OrgStructureController/findOrgStructureTree';
                }
            }
        },
        //生成token
        generateToken(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.genLoading = true;
                    //普通角色
                    let generalRoleList = this.getCheckdRole();
                    //门禁角色
                    let doorRoleList = this.$refs.doorRoleCheckGroup.getCheckList();
                    doorRoleList.forEach(element => {
                        generalRoleList.push(element);
                    });
                    // this.orgIdList.forEach(element => {
                    //     generalRoleList.push(element);
                    // });
                    let param = '';
                    if (this.isDetail) {
                        param = {
                            sId: this.editItem.sId,
                            userName: this.editItem.userName
                        };
                    } else {
                        param = {
                            dateTo: this.formToken.validTime,
                            roleIds: generalRoleList,
                            orgIds: this.orgIdList,
                            tag: this.formToken.tag
                        };
                    }
                    resourceApi.creatThirdPartyToken(param, response => {
                        this.genLoading = false;
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('token/creatThirdPartyToken', response.data.statusMessage);
                            return;
                        }
                        this.nodeShow = true;
                        this.formDisabled = true;
                        this.generateDisabled = true;
                        this.tokenValue = response.data.content.token;
                    });
                }
            });
        },
        //初始化门禁、人事权限
        initDoorRole() {
            let doorListparam = {
                sysID: this.sysFlg,
                orgFlg: window.authCommon.roleType.doorAuthGroup //门禁权限
            };
            let doorListData = [];
            resourceApi.getRoleInfo(JSON.stringify(doorListparam), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getRoleInfo', response.data.statusMessage);
                    return;
                }
                doorListData = response.data.content;
                this.doorRoleList = doorListData;
            });
        },
        //获取角色ID
        getCheckdRole() {
            let checkGroup = this.$refs.roleCheckGroup;
            let checkRoleGroup = [];
            for (let index = 0; index < checkGroup.length; index++) {
                const element = checkGroup[index];
                checkRoleGroup.push(...element.getCheckList());
            }
            return checkRoleGroup;
        },
        showTree() {
            this.dialogOrgTreeVisible = true;
        },
        //打开组织架构树形
        showOrgGroupTree() {
            this.dialogOrgGroupTreeVisible = true;
        },
        //获取选中的组织角色
        getCheckedOrgList(data) {
            let nameList = [];
            let idList = [];
            for (let index = 0; index < data.length; index++) {
                nameList.push(data[index].caption);
                idList.push(data[index].id);
                this.checkedOrgIdList.push({ id: data[index].id, caption: data[index].caption, parentId: data[index].parentId });
            }
            this.orgNameList = nameList;
            this.orgIdList = idList;
        },
        //查询角色信息按角色类型分组
        getAllRoleByType() {
            resourceApi.getAllRoleByType(response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getAllRoleByType', response.data.statusMessage);
                    return;
                }
                this.roleInfoList = response.data.content;
                if (this.isDetail) {
                    this.initEditData();
                }
            });
        },
        //关闭
        tokenDialogClose() {
            this.generateDisabled = false;
            this.$emit('tokenDialogClose');
        },
        //树形dialog关闭
        orgTreeDialogClose() {
            this.dialogOrgTreeVisible = false;
            this.dialogOrgGroupTreeVisible = false;
        }
    }
};
</script>
<style scoped>
.checkboxstyle {
    width: 165px;
    margin: 5px !important;
}
.el-card {
    padding-bottom: 26px;
}
.resultStyle {
    font-size: 16px;
    font-weight: 550;
    padding-left: 10px;
}
.treeStyle {
    min-width: 50px;
    margin: 0 0 0 10px;
}
.genStyle {
    padding-left: 650px;
    margin-top: -10px;
}
</style>
